// Copyright © 2021 Move Closer

import {
  ApiConnectorType,
  AuthServiceType,
  ConnectorMiddleware,
  // CrossDomainLocalStorageProvider,
  DateTime, DateTimeType,
  IConfiguration, IDateTime,
  // ILocalStorage,
  Interfaces,
  // LocalStorageType,
  ModalType,
  ProvidersFactory,
  WindowType
} from '@movecloser/front-core'

import {
  IdentityMiddleware,
  IdentityMiddlewareType,
  IdentityService,
  IdentityServiceType,
  IIdentityService
} from '@service/identity'
import { INavigationService, NavigationService, NavigationServiceType } from '@service/navigation'
import { IPaywallService, PaywallService, PaywallServiceType } from '@service/paywall'
import { IPdfService, PdfService, PdfServiceType } from '@service/pdf'
import {
  IRelatedService,
  RelatedMiddleware,
  RelatedMiddlewareType,
  RelatedService,
  RelatedServiceType,
  relatedTypeDriverRegistryFactory
} from '@service/related'
import { ISetupService, SetupService, SetupServiceType } from '@service/setup'
import { IShareService, ShareService, ShareServiceType } from '@service/share'
import { ISiteService, SiteMiddleware, SiteMiddlewareType, SiteService, SiteServiceType } from '@service/site'
import { IUserComService, UserComService, UserComServiceType } from '@service/usercom'
import { IAnonymousReportService, AnonymousReportService, AnonymousReportServiceType } from '@service/anonymous-reports'
import { shareServiceConfig } from '@config/share'
import { ISubscriptionService, SubscriptionService, SubscriptionServiceType } from '@subscription/shared/services'
import { SubscriptionsRepositoryType } from '@subscription/contracts'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const services: ProvidersFactory = (config: IConfiguration) => {
  return (bind: Interfaces.Bind) => {
    bind<ConnectorMiddleware>(IdentityMiddlewareType).toDynamicValue(
      context => new IdentityMiddleware(context.container.get(IdentityServiceType))
    ).inSingletonScope()

    bind<ConnectorMiddleware>(RelatedMiddlewareType).toDynamicValue(
      context => new RelatedMiddleware(context.container.get(RelatedServiceType))
    ).inSingletonScope()

    bind<ConnectorMiddleware>(SiteMiddlewareType).toDynamicValue(
      context => new SiteMiddleware(context.container.get(SiteServiceType))
    ).inSingletonScope()

    bind<IIdentityService>(IdentityServiceType).to(IdentityService).inSingletonScope()

    bind<INavigationService>(NavigationServiceType).to(NavigationService).inSingletonScope()

    // bind<ILocalStorage>(LocalStorageType).toDynamicValue(() => {
    //   return new CrossDomainLocalStorageProvider(config.byKey('localStorage', false, undefined) ?? undefined)
    // }).inSingletonScope()

    bind<IUserComService>(UserComServiceType).toDynamicValue(
      context => new UserComService(
        context.container.get(ApiConnectorType),
        context.container.get(SiteServiceType)
      )
    )

    bind<IPaywallService>(PaywallServiceType).toDynamicValue(
      context => new PaywallService(context.container.get(ApiConnectorType))
    )

    bind<IPdfService>(PdfServiceType).toDynamicValue(
      context => new PdfService(
        context.container.get(ApiConnectorType),
        context.container.get(ModalType),
        context.container.get(AuthServiceType)
      )
    )

    bind<IRelatedService>(RelatedServiceType).toDynamicValue(
      () => new RelatedService(
        relatedTypeDriverRegistryFactory()
      )
    )

    bind<ISetupService>(SetupServiceType).toDynamicValue(
      context => new SetupService(
        context.container.get(ApiConnectorType),
        context.container.get(IdentityServiceType),
        context.container.get(NavigationServiceType),
        context.container.get(SiteServiceType)
      )
    ).inSingletonScope()

    bind<ISiteService>(SiteServiceType).to(SiteService).inSingletonScope()

    bind<IShareService>(ShareServiceType).toDynamicValue(
      context => new ShareService(
        shareServiceConfig,
        context.container.get(ModalType),
        context.container.get(WindowType),
        context.container.get(SiteServiceType)
      )
    ).inSingletonScope()

    bind<ISubscriptionService>(SubscriptionServiceType).toDynamicValue(
      context => new SubscriptionService(context.container.get(SubscriptionsRepositoryType))
    ).inSingletonScope()

    bind<IAnonymousReportService>(AnonymousReportServiceType).toDynamicValue(
      context => new AnonymousReportService(context.container.get(ApiConnectorType))
    )

    bind<IDateTime>(DateTimeType).to(DateTime).inSingletonScope()
  }
}
